import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const libriMatricolaFiltersSlice = createSlice({
  name: "libriMatricolaFilters",
  initialState,
  reducers: {
    setLibriMatricolaFilters: (state, action) => action.payload,
    clearLibriMatricolaFilters: () => null,
  },
});

export const { setLibriMatricolaFilters, clearLibriMatricolaFilters } =
  libriMatricolaFiltersSlice.actions;
export default libriMatricolaFiltersSlice.reducer;
